import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { packageCategories } from "./constants";

export function PackageSelector({
  packageCategory,
  setPackageCategory,
  packageWeight,
  setPackageWeight,
  packageDescription,
  setPackageDescription
}) {
  return (
    <div className="bg-card border border-border p-6 space-y-4">
      <Label className="font-semibold text-base">What are you sending?</Label>
      <div className="grid grid-cols-4 gap-2">
        {packageCategories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            onClick={() => setPackageCategory(cat.id)}
            className={`p-3 border-2 transition-all text-center ${
              packageCategory === cat.id 
                ? "border-accent bg-accent/5" 
                : "border-border hover:border-accent/50"
            }`}
            data-testid={`package-${cat.id}`}
          >
            <cat.icon className="w-6 h-6 mx-auto mb-1 text-accent" />
            <p className="font-medium text-xs">{cat.name}</p>
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label className="text-sm">Weight (kg)</Label>
          <Input
            type="number"
            placeholder="2"
            value={packageWeight}
            onChange={(e) => setPackageWeight(e.target.value)}
            className="rounded-none mt-1"
            data-testid="package-weight-input"
          />
        </div>
        <div>
          <Label className="text-sm">Description (optional)</Label>
          <Input
            placeholder="e.g. fragile items"
            value={packageDescription}
            onChange={(e) => setPackageDescription(e.target.value)}
            className="rounded-none mt-1"
            data-testid="package-description-input"
          />
        </div>
      </div>
    </div>
  );
}
